import Vue from 'vue';
import campaignEventsUrls from '../../../../urls/campaignEventsUrls';

export const storePrefix = "graph_events_strore";

const state = {
    sessionStorageKey: "graph_events",
    campaignEvents: [],
}

const getters = {
    campaignEvents(state) {
        return state.campaignEvents;
    },
}

const mutations = {
    [`${storePrefix}setCampaignEvents`](state, payload) {
        state.campaignEvents = payload;
    },
}

const actions = {

    saveCampaignEvent(context, { noteDate, noteText }) {
        return new Promise((resolve, reject) => {

            let formData = new FormData();

            //formData.append("file", file);
            //formData.append("fileName", fileName);

            Vue.$http.post(campaignEventsUrls.saveCampaignEvent, {
                noteDate,
                noteText,
            })
                .then((res) => {
                    //context.dispatch('getCampaignEvents').then((data) => {
                        resolve(res);
                    //});
                })
                .catch((er) => reject(er));
            /*Vue.$http.post(campaignEventsUrls.saveCampaignEvent, {
                headers: {
                    //"Content-Type": "multipart/form-data"
                },
                body: {
                    noteDate,
                    noteText,
                }
            });*/



        });
    },

    getCampaignEvents(context) {
        return new Promise((resolve, reject) => {

            let formData = new FormData();

            //formData.append("file", file);
            //formData.append("fileName", fileName);

            Vue.$http.get(campaignEventsUrls.getCampaignEvents, {
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((er) => reject(er));
            /*Vue.$http.post(campaignEventsUrls.saveCampaignEvent, {
                headers: {
                    //"Content-Type": "multipart/form-data"
                },
                body: {
                    noteDate,
                    noteText,
                }
            });*/

           

        });
    },

    getCampaignEventsByDates(context, { from, to }) {
        return new Promise((resolve, reject) => {
            Vue.$http.post(campaignEventsUrls.getCampaignEventsByDates, {
                fromDate: from,
                endDate: to,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((er) => reject(er));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/Common/Graph/store/graph.js